import { defaultColumnConfigMap } from '../ResourceTable/defaultColumnConfigMap.js';

const defaultColumnConfig = [
  defaultColumnConfigMap.preview,
  defaultColumnConfigMap.name,
  defaultColumnConfigMap.tags,
  defaultColumnConfigMap.comments,
  defaultColumnConfigMap.modifiedAt,
  defaultColumnConfigMap.size,
  defaultColumnConfigMap.kind
];
const defaultResourceListPreferences = {
  version: 2,
  coverImage: {
    yOffsetPct: 0
  },
  filters: {
    order: {
      property: "modifiedAt",
      direction: "DESC"
    }
  },
  tableColumns: defaultColumnConfig,
  viewMode: "Grid"
};
const defaultSavePreferences = () => Promise.resolve();

export { defaultResourceListPreferences, defaultSavePreferences };
//# sourceMappingURL=defaultPreferences.js.map
